import React from "react";
import { FiTag } from "react-icons/fi";

export default function EventCategoryBadge({ label }) {
  if (!label) return null;

  return (
    <span className="inline-flex items-center gap-1.5 rounded-full border border-sky-200 bg-sky-50 px-2.5 py-1 text-xs font-bold text-sky-700 dark:border-sky-500/20 dark:bg-sky-500/10 dark:text-sky-300">
      <FiTag />
      {label}
    </span>
  );
}